// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#c2-search-input {\n  height: 48px;\n  /* border-radius: 10px; */\n  -webkit-box-shadow: 0 0 10px #3636361c;\n          box-shadow: 0 0 10px #3636361c;\n  padding-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
